import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toogleAdd } from "../../../Redux/AddOrUpdate/actions";
import addNewBook from "../../../Redux/BookState/Thunk/addNewBook";
import updateBook from "../../../Redux/BookState/Thunk/updateBook";

const BookForm = () => {
  
  const dispatch = useDispatch();

  const books = useSelector((state) => state.bookState);

  const updateAction = useSelector((state) => state.toogleUpdateReducer);

  let bookForUpdate = books.find((book) => book.id === updateAction.id);

  const book = {
    name: "",
    author: "",
    thumbnail: "",
    price: "",
    rating: "",
    featured: "",
  };
  const [bookForm, setBookForm] = useState(book);

  useEffect(() => {
    if (updateAction?.update) {
      setBookForm(bookForUpdate);
    }
  }, [updateAction?.update, bookForUpdate]);


  // onSubmit
  const handleAddBook = (e) => {
    e.preventDefault();
    if (bookForUpdate) {
      dispatch(updateBook(bookForm.id, bookForm));
      dispatch(toogleAdd())
    } else {
      // add new book
      dispatch(addNewBook(bookForm));
    }
    setBookForm(book);
    //form toggle update to add
  };

  // onChange
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    const actualValue = type === 'checkbox' ? checked : value;

    setBookForm({
      ...bookForm,
      [name]: actualValue,
    });
  };

  return (
    <>
      <div>
        <div className="p-4 overflow-hidden bg-white shadow-cardShadow rounded-md">
          <h4 className="mb-8 text-xl font-bold text-center">{updateAction?.update ? 'Update A Book' : 'Add New Book'}</h4>
          <form onSubmit={(e) => handleAddBook(e)} className="book-form">
            <div className="space-y-2">
              <label htmlFor="name">Book Name</label>
              <input
                onChange={handleInputChange}
                value={bookForm.name}
                required
                className="text-input"
                type="text"
                id="input-Bookname"
                name="name"
              />
            </div>

            <div className="space-y-2">
              <label htmlFor="category">Author</label>
              <input
                onChange={handleInputChange}
                value={bookForm.author}
                required
                className="text-input"
                type="text"
                id="input-Bookauthor"
                name="author"
              />
            </div>

            <div className="space-y-2">
              <label htmlFor="image">Image Url</label>
              <input
                onChange={handleInputChange}
                value={bookForm.thumbnail}
                required
                className="text-input"
                type="text"
                id="input-Bookthumbnail"
                name="thumbnail"
              />
            </div>

            <div className="grid grid-cols-2 gap-8 pb-4">
              <div className="space-y-2">
                <label htmlFor="price">Price</label>
                <input
                  onChange={handleInputChange}
                  value={bookForm.price}
                  required
                  className="text-input"
                  type="number"
                  id="input-Bookprice"
                  name="price"
                />
              </div>

              <div className="space-y-2">
                <label htmlFor="quantity">Rating</label>
                <input
                  onChange={handleInputChange}
                  value={bookForm.rating}
                  required
                  className="text-input"
                  type="number"
                  id="input-Bookrating"
                  name="rating"
                  min="1"
                  max="5"
                />
              </div>
            </div>

            <div className="flex items-center">
              <input
                onChange={handleInputChange}
                checked={bookForm.featured}
                id="input-Bookfeatured"
                type="checkbox"
                name="featured"
                className="w-4 h-4"
              />
              <label htmlFor="featured" className="ml-2 text-sm">
                This is a featured book
              </label>
            </div>

            <button type="submit" className="submit" id="submit">
              {updateAction?.update ? 'Update Book' : 'Add Book'}
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default BookForm;
